/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Blokkeer automatisch toevoegen van ?variant=... aan de URL
  document.addEventListener("DOMContentLoaded", function () {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    function cleanVariantParam(url) {
      if (url && typeof url === 'string' && url.includes('variant=')) {
        try {
          const parsed = new URL(url, window.location.origin);
          parsed.searchParams.delete('variant');
          return parsed.pathname + parsed.search;
        } catch (e) {
          return url; // fallback bij relatieve URLs
        }
      }
      return url;
    }

    history.pushState = function (state, title, url) {
      const cleanedUrl = cleanVariantParam(url);
      return originalPushState.call(history, state, title, cleanedUrl);
    };

    history.replaceState = function (state, title, url) {
      const cleanedUrl = cleanVariantParam(url);
      return originalReplaceState.call(history, state, title, cleanedUrl);
    };

    // Strip variant= uit huidige URL als hij er al is
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has('variant')) {
      currentUrl.searchParams.delete('variant');
      window.history.replaceState({}, document.title, currentUrl.pathname);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
